import * as React from 'react';
import MessageBar from '@ane/ui-components/lib/components/MessageBar/MessageBar';
import { MessageBarType } from '@ane/ui-components/lib/components/MessageBar/MessageBar.types';
import { DropdownField } from '@ane/ui-components/lib/components/FormikFormFields/DropdownField';
import { TextField } from '@ane/ui-components/lib/components/TextField';
import { StorageType, dataSourceCreateComponentsName, getPlaceHolder, getValidateMessage, showMSIOption, } from '../../utils/DataSourceFormikSettingsUtils';
import { AuthenticationType, DataLocationStorageType } from '../../models/DataSourceDataCommon';
import { useSelector } from 'react-redux';
import { LocationKeyDetailLabel, } from '../../../DataSourceDetail/components/DataSourceLocation/DataSourceLocation';
import FormActions from '@ane/ui-components/lib/components/FormActions/FormActions';
import { PrimaryButton } from '@ane/ui-components/lib/components/Button/PrimaryButton';
import { DataLocationComponentConstants } from '../../../../constants/DataSource.constants';
import { DefaultButton } from '@ane/ui-components/lib/components/Button/DefaultButton';
import Dialog from '@ane/ui-components/lib/components/Dialog/Dialog';
import { ButtonDialogType } from '@ane/ui-components/lib/components/Dialog/ButtonDialog.types';
import { useState } from 'react';
export function DataLocationAuthtencationFileds(props) {
    var _a, _b;
    const { isCreate } = props;
    const [showConfirmDialog, setShowConfirmDialog] = useState(false);
    const [spNewValue, setSPNewValue] = useState('');
    const workspaceId = useSelector((state) => { var _a, _b; return ((_b = (_a = state.currentUserDetails.userAffinity) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.workspaceId) || ''; });
    const servicePrincipalList = useSelector((state) => state.dataSourceManagementModule.servicePrincipalList.res);
    const originalSP = useSelector((state) => { var _a, _b, _c, _d; return (_d = (_c = (_b = (_a = state.dataSourceManagementModule.dataSource) === null || _a === void 0 ? void 0 : _a.items) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.AuthenticationId) !== null && _d !== void 0 ? _d : ''; });
    const managedIdentityList = useSelector((state) => { var _a; return (_a = state.dataSourceManagementModule.managedIdentityList) === null || _a === void 0 ? void 0 : _a.res; });
    const _generateAuthenticationTypeDownField = (storageType) => {
        if (storageType === DataLocationStorageType.ADLSGen2 ||
            storageType === DataLocationStorageType.AzureBlob ||
            storageType === DataLocationStorageType.ADLSGen2CosmosView ||
            storageType === DataLocationStorageType.Cosmos) {
            return (React.createElement(DropdownField, { name: 'authenticationType', required: true, label: "Authentication type", placeholder: "Please select your authentication type", ariaLabel: 'Authentication type', options: _getAuthenticationTypeOptions(storageType), isReadOnly: !!props.isReadOnly, defaultSelectedKey: _getAuthenticationTypeDefaultValue(storageType), onChange: (ev, option) => {
                    var _a;
                    if (!option) {
                        return;
                    }
                    else {
                        (_a = props.formikProps) === null || _a === void 0 ? void 0 : _a.setFieldValue('authenticationType', option.key.toString(), true);
                    }
                } }));
        }
    };
    const _getAuthenticationTypeOptions = (storageType) => {
        let options = [];
        if (storageType === DataLocationStorageType.ADLSGen2) {
            options = [
                {
                    key: AuthenticationType.ServicePrincipal,
                    text: AuthenticationType.ServicePrincipal,
                },
                { key: AuthenticationType.Secret, text: AuthenticationType.Secret },
            ];
        }
        else if (storageType === DataLocationStorageType.AzureBlob) {
            options = [
                {
                    key: AuthenticationType.Legacy,
                    text: AuthenticationType.Legacy,
                },
            ];
        }
        else if (storageType === DataLocationStorageType.ADLSGen2CosmosView) {
            options = [
                {
                    key: AuthenticationType.ServicePrincipal,
                    text: AuthenticationType.ServicePrincipal,
                },
            ];
        }
        else if (storageType === DataLocationStorageType.Cosmos) {
            options = [
                {
                    key: AuthenticationType.Legacy,
                    text: AuthenticationType.Legacy,
                },
            ];
        }
        if (showMSIOption(workspaceId)) {
            options = [
                {
                    key: AuthenticationType.ManagedIdentity,
                    text: AuthenticationType.ManagedIdentity,
                },
                ...options,
            ];
        }
        return options;
    };
    const _getAuthenticationTypeDefaultValue = (storageType) => {
        if (showMSIOption(workspaceId)) {
            if (storageType === DataLocationStorageType.ADLSGen2) {
                return props.formikProps.values.managedIdentityId !== '' && props.formikProps.values.managedIdentityId !== null
                    ? AuthenticationType.ManagedIdentity
                    : props.formikProps.values.authenticationId !== '' && props.formikProps.values.authenticationId !== null
                        ? AuthenticationType.ServicePrincipal
                        : AuthenticationType.Secret;
            }
            else if (storageType === DataLocationStorageType.AzureBlob) {
                return props.formikProps.values.managedIdentityId !== '' && props.formikProps.values.managedIdentityId !== null
                    ? AuthenticationType.ManagedIdentity
                    : AuthenticationType.Legacy;
            }
            else if (storageType === DataLocationStorageType.ADLSGen2CosmosView) {
                return props.formikProps.values.managedIdentityId !== '' && props.formikProps.values.managedIdentityId !== null
                    ? AuthenticationType.ManagedIdentity
                    : AuthenticationType.ServicePrincipal;
            }
            else if (storageType === DataLocationStorageType.Cosmos) {
                return props.formikProps.values.managedIdentityId !== '' && props.formikProps.values.managedIdentityId !== null
                    ? AuthenticationType.ManagedIdentity
                    : AuthenticationType.Legacy;
            }
        }
        else {
            if (storageType === DataLocationStorageType.ADLSGen2) {
                return props.formikProps.values.authenticationId !== '' && props.formikProps.values.authenticationId !== null
                    ? AuthenticationType.ServicePrincipal
                    : AuthenticationType.Secret;
            }
            else if (storageType === DataLocationStorageType.AzureBlob) {
                return AuthenticationType.Legacy;
            }
            else if (storageType === DataLocationStorageType.ADLSGen2CosmosView) {
                return AuthenticationType.ServicePrincipal;
            }
            else if (storageType === DataLocationStorageType.Cosmos) {
                return AuthenticationType.Legacy;
            }
        }
    };
    const _generateAuthenticationFields = () => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27;
        const dataLocationComponentList = [];
        if (((_b = (_a = props.formikProps) === null || _a === void 0 ? void 0 : _a.values) === null || _b === void 0 ? void 0 : _b.storageType) === StorageType.ADLSGen2) {
            // switch dropdown
            if (!!((_d = (_c = props.formikProps) === null || _c === void 0 ? void 0 : _c.values) === null || _d === void 0 ? void 0 : _d.authenticationType)) {
                if (showMSIOption(workspaceId) && ((_f = (_e = props.formikProps) === null || _e === void 0 ? void 0 : _e.values) === null || _f === void 0 ? void 0 : _f.authenticationType) === AuthenticationType.ManagedIdentity) {
                    dataLocationComponentList.push(..._generateMSIDropdownField(isCreate, managedIdentityList));
                }
                else if (((_h = (_g = props.formikProps) === null || _g === void 0 ? void 0 : _g.values) === null || _h === void 0 ? void 0 : _h.authenticationType) === AuthenticationType.ServicePrincipal) {
                    dataLocationComponentList.push(..._generateServicePrincipalDropdownFields(isCreate, servicePrincipalList));
                }
                else {
                    dataLocationComponentList.push(_getCommonTextField('Url'));
                    dataLocationComponentList.push(_getCommonTextField('SecretName'));
                }
            }
            else {
                // update for MSI
                if (showMSIOption(workspaceId) &&
                    ((_k = (_j = props.formikProps) === null || _j === void 0 ? void 0 : _j.values) === null || _k === void 0 ? void 0 : _k.managedIdentityId) !== '' &&
                    ((_m = (_l = props.formikProps) === null || _l === void 0 ? void 0 : _l.values) === null || _m === void 0 ? void 0 : _m.managedIdentityId) !== null) {
                    dataLocationComponentList.push(..._generateMSIDropdownField(isCreate, managedIdentityList));
                }
                // update for SP
                else if (((_p = (_o = props.formikProps) === null || _o === void 0 ? void 0 : _o.values) === null || _p === void 0 ? void 0 : _p.authenticationId) !== '' && ((_r = (_q = props.formikProps) === null || _q === void 0 ? void 0 : _q.values) === null || _r === void 0 ? void 0 : _r.authenticationId) !== null) {
                    dataLocationComponentList.push(..._generateServicePrincipalDropdownFields(isCreate, servicePrincipalList));
                }
                // update for secret
                else {
                    dataLocationComponentList.push(_getCommonTextField('Url'));
                    dataLocationComponentList.push(_getCommonTextField('SecretName'));
                }
            }
            return dataLocationComponentList;
        }
        else if (((_t = (_s = props.formikProps) === null || _s === void 0 ? void 0 : _s.values) === null || _t === void 0 ? void 0 : _t.storageType) === StorageType.AzureBlob) {
            // switch dropdown
            if (!!((_v = (_u = props.formikProps) === null || _u === void 0 ? void 0 : _u.values) === null || _v === void 0 ? void 0 : _v.authenticationType)) {
                if (showMSIOption(workspaceId) && ((_x = (_w = props.formikProps) === null || _w === void 0 ? void 0 : _w.values) === null || _x === void 0 ? void 0 : _x.authenticationType) === AuthenticationType.ManagedIdentity) {
                    dataLocationComponentList.push(..._generateMSIDropdownField(isCreate, managedIdentityList));
                }
            }
            else {
                // update for MSI
                if (showMSIOption(workspaceId) &&
                    ((_z = (_y = props.formikProps) === null || _y === void 0 ? void 0 : _y.values) === null || _z === void 0 ? void 0 : _z.managedIdentityId) !== '' &&
                    ((_1 = (_0 = props.formikProps) === null || _0 === void 0 ? void 0 : _0.values) === null || _1 === void 0 ? void 0 : _1.managedIdentityId) !== null) {
                    dataLocationComponentList.push(..._generateMSIDropdownField(isCreate, managedIdentityList));
                }
            }
            return dataLocationComponentList;
        }
        else if (((_3 = (_2 = props.formikProps) === null || _2 === void 0 ? void 0 : _2.values) === null || _3 === void 0 ? void 0 : _3.storageType) === StorageType.ADLSGen2CosmosView) {
            // switch dropdown
            if (!!((_5 = (_4 = props.formikProps) === null || _4 === void 0 ? void 0 : _4.values) === null || _5 === void 0 ? void 0 : _5.authenticationType)) {
                if (showMSIOption(workspaceId) && ((_7 = (_6 = props.formikProps) === null || _6 === void 0 ? void 0 : _6.values) === null || _7 === void 0 ? void 0 : _7.authenticationType) === AuthenticationType.ManagedIdentity) {
                    dataLocationComponentList.push(..._generateMSIDropdownField(isCreate, managedIdentityList));
                }
                else if (((_9 = (_8 = props.formikProps) === null || _8 === void 0 ? void 0 : _8.values) === null || _9 === void 0 ? void 0 : _9.authenticationType) === AuthenticationType.ServicePrincipal) {
                    dataLocationComponentList.push(..._generateServicePrincipalDropdownFields(isCreate, servicePrincipalList));
                }
            }
            else {
                // update for MSI
                if (showMSIOption(workspaceId) &&
                    ((_11 = (_10 = props.formikProps) === null || _10 === void 0 ? void 0 : _10.values) === null || _11 === void 0 ? void 0 : _11.managedIdentityId) !== '' &&
                    ((_13 = (_12 = props.formikProps) === null || _12 === void 0 ? void 0 : _12.values) === null || _13 === void 0 ? void 0 : _13.managedIdentityId) !== null) {
                    dataLocationComponentList.push(..._generateMSIDropdownField(isCreate, managedIdentityList));
                }
                // update for SP
                else if (((_15 = (_14 = props.formikProps) === null || _14 === void 0 ? void 0 : _14.values) === null || _15 === void 0 ? void 0 : _15.authenticationId) !== '' && ((_17 = (_16 = props.formikProps) === null || _16 === void 0 ? void 0 : _16.values) === null || _17 === void 0 ? void 0 : _17.authenticationId) !== null) {
                    dataLocationComponentList.push(..._generateServicePrincipalDropdownFields(isCreate, servicePrincipalList));
                }
            }
            return dataLocationComponentList;
        }
        else if (((_19 = (_18 = props.formikProps) === null || _18 === void 0 ? void 0 : _18.values) === null || _19 === void 0 ? void 0 : _19.storageType) === StorageType.Cosmos) {
            // switch dropdown
            if (!!((_21 = (_20 = props.formikProps) === null || _20 === void 0 ? void 0 : _20.values) === null || _21 === void 0 ? void 0 : _21.authenticationType)) {
                if (showMSIOption(workspaceId) && ((_23 = (_22 = props.formikProps) === null || _22 === void 0 ? void 0 : _22.values) === null || _23 === void 0 ? void 0 : _23.authenticationType) === AuthenticationType.ManagedIdentity) {
                    dataLocationComponentList.push(..._generateMSIDropdownField(isCreate, managedIdentityList));
                }
            }
            else {
                // update for MSI
                if (showMSIOption(workspaceId) &&
                    ((_25 = (_24 = props.formikProps) === null || _24 === void 0 ? void 0 : _24.values) === null || _25 === void 0 ? void 0 : _25.managedIdentityId) !== '' &&
                    ((_27 = (_26 = props.formikProps) === null || _26 === void 0 ? void 0 : _26.values) === null || _27 === void 0 ? void 0 : _27.managedIdentityId) !== null) {
                    dataLocationComponentList.push(..._generateMSIDropdownField(isCreate, managedIdentityList));
                }
            }
            return dataLocationComponentList;
        }
    };
    const _generateMSIDropdownField = (isCreate, managedIdentityList) => {
        var _a, _b;
        const dataLocationComponentList = [];
        let options = (managedIdentityList === null || managedIdentityList === void 0 ? void 0 : managedIdentityList.data)
            ? (_a = managedIdentityList === null || managedIdentityList === void 0 ? void 0 : managedIdentityList.data) === null || _a === void 0 ? void 0 : _a.map((item) => ({ key: item.objectId, text: item.name }))
            : [];
        let errorMessage = '';
        if (managedIdentityList === null || managedIdentityList === void 0 ? void 0 : managedIdentityList.error) {
            errorMessage = 'Managed identity list failed to load, please try again later and refresh the page.';
        }
        else if (!options || options.length === 0) {
            errorMessage = 'No managed identity exist, please create a user managed identity first and refresh the page.';
        }
        dataLocationComponentList.push(React.createElement(React.Fragment, null,
            React.createElement(DropdownField, { name: "managedIdentity", required: true, label: "Managed identity", placeholder: "Please select your managed identity", ariaLabel: 'Managed identity', options: options, isReadOnly: !!props.isReadOnly, defaultSelectedKey: (_b = props.formikProps.values.managedIdentityId) !== null && _b !== void 0 ? _b : '', errorMessage: getMSIErrorMessage(), onChange: (ev, option) => {
                    var _a, _b;
                    if (!option) {
                        return;
                    }
                    (_a = props.formikProps) === null || _a === void 0 ? void 0 : _a.setFieldValue('managedIdentityId', option.key.toString(), true);
                    (_b = props.formikProps) === null || _b === void 0 ? void 0 : _b.setFieldValue('managedIdentityName', option.text.toString(), true);
                } }),
            errorMessage ? (React.createElement(MessageBar, { messageBarType: MessageBarType.error, isMultiline: false, dismissButtonAriaLabel: "Close", ariaLabel: 'Managed identity Error message' }, errorMessage)) : (React.createElement(React.Fragment, null))));
        return dataLocationComponentList;
    };
    const _generateServicePrincipalDropdownFields = (isCreate, servicePrincipalList) => {
        var _a, _b, _c;
        const dataLocationComponentList = [];
        let options = ((_a = servicePrincipalList === null || servicePrincipalList === void 0 ? void 0 : servicePrincipalList.data) === null || _a === void 0 ? void 0 : _a.value)
            ? (_b = servicePrincipalList === null || servicePrincipalList === void 0 ? void 0 : servicePrincipalList.data) === null || _b === void 0 ? void 0 : _b.value.map((item) => ({ key: item.id, text: item.displayName }))
            : [];
        let errorMessage = '';
        if (!isCreate) {
            const isItemOfOptions = options.find((item) => item.key === originalSP);
            if (!isItemOfOptions && originalSP) {
                options.push({
                    key: originalSP !== null && originalSP !== void 0 ? originalSP : '',
                    text: originalSP !== null && originalSP !== void 0 ? originalSP : '',
                });
            }
        }
        if (servicePrincipalList === null || servicePrincipalList === void 0 ? void 0 : servicePrincipalList.error) {
            errorMessage = 'Service principal list failed to load, please try again later and refresh the page.';
        }
        else if (!options || options.length === 0) {
            errorMessage = 'No service principals exist, please create a principal first and refresh the page.';
        }
        dataLocationComponentList.push(React.createElement(React.Fragment, null,
            React.createElement(DropdownField, { name: "authenticationId", required: true, label: "Service Principal Name", placeholder: "Please select your service principal", ariaLabel: 'Service Principal Name', options: options, isReadOnly: !!props.isReadOnly, defaultSelectedKey: (_c = props.formikProps.values.authenticationId) !== null && _c !== void 0 ? _c : '', errorMessage: getSPErrorMessage(), onChange: (ev, option) => {
                    var _a, _b, _c;
                    if (!option) {
                        return;
                    }
                    const isServicePrincipalUpdated = originalSP && originalSP !== option.key.toString();
                    const isOriginalSPExistInList = (_b = (_a = servicePrincipalList === null || servicePrincipalList === void 0 ? void 0 : servicePrincipalList.data) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.find((item) => item.id === originalSP);
                    if (!isCreate && isServicePrincipalUpdated && !isOriginalSPExistInList) {
                        setShowConfirmDialog(true);
                        setSPNewValue(option.key.toString());
                    }
                    else {
                        (_c = props.formikProps) === null || _c === void 0 ? void 0 : _c.setFieldValue('authenticationId', option.key.toString(), true);
                    }
                } }),
            errorMessage ? (React.createElement(MessageBar, { messageBarType: MessageBarType.error, isMultiline: false, dismissButtonAriaLabel: "Close", ariaLabel: 'Service principal Error message' }, errorMessage)) : (React.createElement(React.Fragment, null))));
        return dataLocationComponentList;
    };
    const _getCommonTextField = (Name) => {
        var _a, _b, _c;
        const onChange = (_, option) => {
            var _a, _b, _c, _d, _e;
            let dataLocationForms = (_b = (_a = props.formikProps) === null || _a === void 0 ? void 0 : _a.values) === null || _b === void 0 ? void 0 : _b.storageList;
            dataLocationForms = {
                ...(_d = (_c = props.formikProps) === null || _c === void 0 ? void 0 : _c.values) === null || _d === void 0 ? void 0 : _d.storageList,
                [Name]: option,
            };
            (_e = props.formikProps) === null || _e === void 0 ? void 0 : _e.setFieldValue('storageList', dataLocationForms, true);
        };
        const value = (_c = (_b = (_a = props.formikProps) === null || _a === void 0 ? void 0 : _a.values) === null || _b === void 0 ? void 0 : _b.storageList) === null || _c === void 0 ? void 0 : _c[Name];
        return _getTextField(Name, onChange, value);
    };
    const _getTextField = (Name, onChange, value, options) => {
        var _a, _b, _c, _d, _e, _f, _g;
        return (React.createElement(TextField, { label: `${LocationKeyDetailLabel[Name]}`, required: true, isReadOnly: !!props.isReadOnly, ariaLabel: `Please enter ${LocationKeyDetailLabel[Name]}`, description: getPlaceHolder(dataSourceCreateComponentsName.datalocationinfo, Name, (_b = (_a = props.formikProps) === null || _a === void 0 ? void 0 : _a.values) === null || _b === void 0 ? void 0 : _b.storageType), value: value || '', errorMessage: getValidateMessage(Name, (_e = (_d = (_c = props.formikProps) === null || _c === void 0 ? void 0 : _c.values) === null || _d === void 0 ? void 0 : _d.storageList) === null || _e === void 0 ? void 0 : _e[Name], ((_g = (_f = props.formikProps) === null || _f === void 0 ? void 0 : _f.values) === null || _g === void 0 ? void 0 : _g.authenticationType) === AuthenticationType.ServicePrincipal), onChange: onChange, ...options }));
    };
    const getSPErrorMessage = () => {
        var _a, _b, _c;
        if (((_a = props.formikProps.values) === null || _a === void 0 ? void 0 : _a.storageType) === DataLocationStorageType.ADLSGen2) {
            if (!((_b = props.formikProps.values) === null || _b === void 0 ? void 0 : _b.authenticationType) ||
                ((_c = props.formikProps.values) === null || _c === void 0 ? void 0 : _c.authenticationType) === AuthenticationType.ServicePrincipal) {
                return props.formikProps.values.authenticationId ? '' : 'Required';
            }
            else {
                return '';
            }
        }
        return props.formikProps.values.authenticationId ? '' : 'Required';
    };
    const getMSIErrorMessage = () => {
        var _a, _b;
        if (!((_a = props.formikProps.values) === null || _a === void 0 ? void 0 : _a.authenticationType) ||
            ((_b = props.formikProps.values) === null || _b === void 0 ? void 0 : _b.authenticationType) === AuthenticationType.ManagedIdentity) {
            return props.formikProps.values.managedIdentityId ? '' : 'Required';
        }
        else {
            return '';
        }
    };
    const _onDismissDialog = () => {
        var _a;
        setShowConfirmDialog(false);
        (_a = props.formikProps) === null || _a === void 0 ? void 0 : _a.setFieldValue('authenticationId', originalSP, false);
        setSPNewValue('');
    };
    const _onConfirmDialog = () => {
        var _a;
        setShowConfirmDialog(false);
        (_a = props.formikProps) === null || _a === void 0 ? void 0 : _a.setFieldValue('authenticationId', spNewValue, false);
        setSPNewValue('');
    };
    return (React.createElement(React.Fragment, null,
        _generateAuthenticationTypeDownField((_b = (_a = props.formikProps) === null || _a === void 0 ? void 0 : _a.values) === null || _b === void 0 ? void 0 : _b.storageType),
        _generateAuthenticationFields(),
        React.createElement(Dialog, { hidden: !showConfirmDialog, dialogContentProps: {
                title: DataLocationComponentConstants.SPDoubleConfirmDialog.title,
                type: ButtonDialogType.normal,
            }, maxWidth: 600, minWidth: 500, modalProps: {
                isBlocking: false,
            }, onRenderFooter: () => (React.createElement(FormActions, null,
                React.createElement(PrimaryButton, { ariaLabel: DataLocationComponentConstants.SPDoubleConfirmDialog.confirmBtn.ariaLabel, onClick: _onConfirmDialog, text: DataLocationComponentConstants.SPDoubleConfirmDialog.confirmBtn.label }),
                React.createElement(DefaultButton, { ariaLabel: DataLocationComponentConstants.SPDoubleConfirmDialog.cancelBtn.ariaLabel, onClick: _onDismissDialog, text: DataLocationComponentConstants.SPDoubleConfirmDialog.cancelBtn.ariaLabel }))) },
            DataLocationComponentConstants.SPDoubleConfirmDialog.subText,
            React.createElement("br", null),
            DataLocationComponentConstants.SPDoubleConfirmDialog.getInfo(originalSP !== null && originalSP !== void 0 ? originalSP : ''))));
}
export default DataLocationAuthtencationFileds;

//# sourceMappingURL=DataLocationAuthtencationFileds.js.map
